import React, { useState } from 'react';
import { myAxios } from '../services/Helper';
import './admin.css';

const ChangeUserRole = () => {
    const [formData, setFormData] = useState({
        userEmail: '',
        role: 'ROLE_USER'
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);

        try {
            const response = await myAxios.post('/api/user/auth/change-role', formData);
            setMessage({ type: 'success', text: 'User role updated successfully!' });
            // Clear form after successful update
            setFormData({
                userEmail: '',
                role: 'ROLE_USER'
            });
        } catch (error) {
            setMessage({
                type: 'error',
                text: error.response?.data?.message || 'Failed to update user role. Please try again.'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-section">
            <h2>Change User Role</h2>
            <div className="info-message">
                <i className="info-icon">ℹ️</i>
                <span>Update user roles by entering their email address</span>
            </div>

            <form onSubmit={handleSubmit} className="admin-form">
                <div className="form-group">
                    <label htmlFor="userEmail">User Email</label>
                    <input
                        type="email"
                        id="userEmail"
                        name="userEmail"
                        value={formData.userEmail}
                        onChange={handleChange}
                        required
                        placeholder="Enter user email"
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="role">New Role</label>
                    <select
                        id="role"
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        required
                    >
                        <option value="ROLE_USER">User</option>
                        <option value="ROLE_SUBADMIN">Sub Admin</option>
                        <option value="ROLE_ADMIN">Admin</option>
                    </select>
                </div>

                {message && (
                    <div className={`message ${message.type}`}>
                        {message.text}
                    </div>
                )}

                <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? 'Updating...' : 'Update Role'}
                </button>
            </form>
        </div>
    );
};

export default ChangeUserRole;